import { useEffect, useState } from 'react'
import { useMenuApi } from '../hooks/useMenuApi'
import MenuDisplay from '../components/MenuDisplay'
import '../views/FriterieSection.css'

const FriterieSection = () => {
  const { menu, loading, error } = useMenuApi({ load: true })
  const [activeTab, setActiveTab] = useState(null)
  const [isReady, setIsReady] = useState(false) // <-- attendre le chargement complet

  useEffect(() => {
    if (!loading && menu && menu.sections.length > 0) {
      setActiveTab(menu.sections[0].id)
      // petite pause pour smooth render (facultatif)
      const timer = setTimeout(() => setIsReady(true), 150) 
      return () => clearTimeout(timer)
    }
  }, [loading, menu])

  // pendant le chargement, on garde le layout minimal pour éviter le flicker
  if (!isReady) {
    return (
      <section className="friterie">
        <section className="friterie">
          <div className="friterie-her">
            <p className="friterie-hero-subtitle">Chargement du menu…</p>
          </div>
        </section>
      </section>
    )
  }

  return (
    

      <main className="friterie-main">
        {error && <p>{error}</p>}
        {menu && (
          <MenuDisplay
            menu={menu}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            mode="view"
          />
        )}
      </main>
  )
}

export default FriterieSection
